export default __webpack_public_path__ + "static/media/UK.75394531.svg";